export const addPermissionDialogTranslations = {
    en: {
        permission: "Permission",
        permissionRequired: "Please enter Permission",
        submit: "Submit",
        createSuccess: "Permission created successfully",
        updateSuccess: "Permission details updated",
        submitError: "An error occurred"
    },
    mr: {
        permission: "परवानगी",
        permissionRequired: "कृपया परवानगी प्रविष्ट करा",
        submit: "सबमिट करा",
        createSuccess: "परवानगी यशस्वीरित्या तयार केली",
        updateSuccess: "परवानगी तपशील अपडेट केले",
        submitError: "एक त्रुटी उद्भवली"
    }
};
